import React from "react"
import { HeadingWithParagraphs } from "../Common/HeadingWithParagraph/HeadingWithParagraphs"
import Image from "next/image"
import { effectiveDataProps, topImageAndheadingEffectiveDataProps } from "@/lib/content/weddingBudgetContent/budgetEffectiveData"

export const BudgetEffectiveTemplate = ({
    effectiveData,
    topContent
}: {
    effectiveData: effectiveDataProps[],
    topContent: topImageAndheadingEffectiveDataProps
}) => {


    return (
        <div className="relative w-full  bg-secondary " >
            <div className="p-5 pt-12 desktop-padding relative z-10" >
                <h2 className="h2 text-center " >{topContent.heading}</h2>
                {
                    topContent.screenShot && (
                        <div className="mt-[28px] flex justify-center" >
                            <Image className="w-auto h-auto" src={topContent.screenShot} alt={topContent.screenShotAlt} width={1240} height={600} />
                        </div>
                    )
                }
                <div className="mt-[24px]" >
                    {
                        topContent.paraContent.map((para) => (
                            <p key={para} className="mt-3 body-reg ">{para}</p>
                        ))
                    }
                </div>
                {
                    effectiveData && (
                        <div>
                            {effectiveData.map((content) => (
                                <HeadingWithParagraphs content={content} />
                            ))}
                        </div>
                    )
                }

            </div>
        </div>
    )
}